import { getAnswersData } from '../common.js';
import { getBmiStatus } from '../common/bmi-range.js';
import { isInViewport } from '../helpers.js';

function bmiGraph() {
  let bmiAnimations = document.querySelectorAll('.bmi-animations');
  let bmiStatus = getBmiStatus();
  let bmiData = Number(getAnswersData('bmi')).toFixed(1);
  let bmiPhase;
  let bmiText;

  function setBmiPhase() {
    if (bmiStatus === 'underweight') {
      bmiPhase = 'bmi-phase-1';
      bmiText = 'bmi-underweight';
    } else if (bmiStatus === 'normal') {
      bmiPhase = 'bmi-phase-2';
      bmiText = 'bmi-normal';
    } else if (bmiStatus === 'overweight') {
      bmiPhase = 'bmi-phase-3';
      bmiText = 'bmi-overweight';
    } else {
      bmiPhase = 'bmi-phase-4';
      if (bmiStatus === 'obesity-one') {
        bmiText = 'bmi-obesity-one';
      } else if (bmiStatus === 'obesity-two') {
        bmiText = 'bmi-obesity-two';
      } else {
        bmiText = 'bmi-obesity-three';
      }
    }
  }

  setBmiPhase();
  bmiAnimations.forEach(bmi => {
    if (bmi.id !== bmiPhase) {
      bmi.remove();
    } else {
      document.querySelector(`#${bmi.id}-tspan1`).innerHTML = bmiData;
      document.querySelector(`.${bmiText}`).classList.remove('none');
    }
  });
}

function caloriesGraph() {
  let calorieAnimations = document.querySelectorAll('.js-cal');
  let elCaloriesFrom = document.querySelector('.js-calories-from');
  let elCaloriesTo = document.querySelector('.js-calories-to');
  let caloriesPhase;
  let calories = getAnswersData('calories');
  let caloriesFrom = getAnswersData('calories_from');
  let caloriesTo = getAnswersData('calories_to');

  function setCaloriesPhase() {
    if (calories < 1250) {
      caloriesPhase = 'calories-phase-1';
    } else if (calories >= 1250 && calories < 2500) {
      caloriesPhase = 'calories-phase-2';
    } else if (calories >= 2500 && calories < 3750) {
      caloriesPhase = 'calories-phase-3';
    } else {
      caloriesPhase = 'calories-phase-4';
    }
  }

  setCaloriesPhase();

  calorieAnimations.forEach(calItem => {
    if (calItem.id !== caloriesPhase) {
      calItem.remove();
    } else {
      elCaloriesFrom.innerHTML = caloriesFrom;
      elCaloriesTo.innerHTML = caloriesTo;
      document.querySelector(`#${calItem.id}-tspan4`).innerHTML = `${caloriesFrom} - ${caloriesTo}`;
    }
  });
}

function getAge() {
  if (getAnswersData('age')) {
    return getAnswersData('age');
  }
  if (Object.values(store.getAnswers()) && store.getAnswers().measurements) {
    return Object.values(store.getAnswers().measurements)[0].value;
  }
  return false;
}

function metabolicGraph() {
  let metabolicAnimations = document.querySelectorAll('.js-metabolic');
  let metabolicAge = Number(getAnswersData('metabolic_age'));
  let age = Number(getAge()) || 0;
  let agePhase;

  function setAgePhase() {
    if (age < metabolicAge) {
      agePhase = 'metabolic-age-phase-1';
    } else if (age === metabolicAge) {
      agePhase = 'metabolic-age-phase-2';
    } else {
      agePhase = 'metabolic-age-phase-3';
    }
  }

  setAgePhase();

  metabolicAnimations.forEach(metabolic => {
    if (metabolic.id !== agePhase) {
      metabolic.remove();
    } else {
      metabolic.classList.add(agePhase);
      document.querySelector(`#meta-phase-1`).innerHTML = metabolicAge;
      document.querySelector(`#meta-phase-2`).innerHTML = store.get('age-range') || backEndVars.ageRange || age;
    }
  });
}

function weightGraph() {
  const measurementUnitContainers = document.querySelectorAll('.js-measurement-unit');
  const noData = Object.entries(store.getAnswers()).length === 0;
  if (measurementUnitContainers.length === 0 || noData) {
    return;
  }

  const weightUnit =
    getAnswersData('weight_unit') ||
    getAnswersData('weight')?.unit ||
    store.getAnswers()?.measurements[0]?.unit ||
    'kg';
  measurementUnitContainers.forEach(e => (e.innerHTML = ' ' + weightUnit));
  const currentWeight =
    Number(getAnswersData('weight')) ||
    Number(getAnswersData('weight')?.value) ||
    Number(store.getAnswers()?.measurements[0]?.value) ||
    63;
  const achievableWeight = Number(getAnswersData('achievable_weight'));

  const currentGraph = getRegimentType();
  document.querySelectorAll('.js-weight').forEach(e => !e.classList.contains(currentGraph) && e.remove());

  let weightFrom = document.querySelector('.js-weight-from');
  let weightTo = document.querySelector('.js-weight-to');
  let achievableWeightElement = document.querySelector('.js-achievable-weight');

  if (weightFrom) {
    weightFrom.innerHTML = currentWeight.toFixed(1);
  }

  if (weightTo) {
    weightTo.innerHTML = achievableWeight.toFixed(1);
  }

  if (achievableWeightElement) {
    achievableWeightElement.innerHTML = achievableWeight.toFixed(1);
  }

  function getRegimentType() {
    const regimentType = getAnswersData('regiment_type');

    const graphSelectors = {
      keep: 'js-keep-weight',
      lose: 'js-lose-weight',
      gain: 'js-gain-weight',
    };

    document.querySelector('.js-weight-data')?.classList.add(regimentType);
    return graphSelectors[regimentType];
  }
}

function waterGraph() {
  const recommendedWater = getAnswersData('recommended_water');
  const bottlesToFill = Math.floor(recommendedWater) > 4 ? 4 : Math.floor(recommendedWater);
  const hasLeftToFill = (+recommendedWater - Math.floor(recommendedWater)).toFixed(1) > 0 && bottlesToFill < 4;
  const bottles = document.querySelectorAll('.single-bottle');

  if (bottles.length === 0) {
    return;
  }

  for (let bottleIndex = 0; bottleIndex < bottlesToFill; bottleIndex++) {
    fillBottle(bottles[bottleIndex], 'full');
  }

  hasLeftToFill && fillBottle(bottles[bottlesToFill]);

  function fillBottle(element, litersTofill) {
    const bottle = element.querySelector('span');
    if (litersTofill == 'full') {
      bottle.style.animation = '.9s bottle';
      bottle.style.animationFillMode = 'forwards';
    } else {
      element.classList.add('single-bottle--semifilled');
    }
  }
}

function helpBlock() {
  document.querySelectorAll('.js-help-btn').forEach(element => {
    element.addEventListener('click', e => {
      e.preventDefault();
      e.target.closest('.m-item-summary')
        ? e.target.closest('.m-item-summary').classList.toggle('m-item-summary--active')
        : e.target.closest('.summary-item') &&
          e.target.closest('.summary-item').classList.toggle('m-item-summary--active');
      e.target.closest('.js-summary-item') && e.target.closest('.js-summary-item').classList.toggle('active-help');
    });
  });
}

let hasNotClickedScroll = true;

document.querySelector('.js-scroll')?.addEventListener('click', () => {
  hasNotClickedScroll = false;
  setTimeout(() => {
    hasNotClickedScroll = true;
  }, 1500);
});

function loadAnimations() {
  document.querySelectorAll('.js-animation').forEach(e => {
    if (isInViewport(e.parentNode, 200) && hasNotClickedScroll) {
      e.parentNode.querySelectorAll('.js-stressless').forEach(e => e.classList.add('active'));
      e.parentNode.querySelectorAll('.hidden').forEach(e => {
        e.classList.remove('hidden');
      });
    }
  });
}

document.addEventListener('scroll', () => {
  loadAnimations();
});

document.addEventListener('DOMContentLoaded', () => {
  bmiGraph();
  caloriesGraph();
  metabolicGraph();
  helpBlock();
  waterGraph();
  weightGraph();
  loadAnimations();
});
